
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.10.1
 * Query Engine version: 9b628578b3b7cae625e8c927178f15a170e74a9c
 */
Prisma.prismaVersion = {
  client: "6.10.1",
  engine: "9b628578b3b7cae625e8c927178f15a170e74a9c"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ProviderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  image: 'image',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  meta: 'meta',
  service: 'service',
  website: 'website',
  deletedAt: 'deletedAt'
};

exports.Prisma.PromptScalarFieldEnum = {
  id: 'id',
  prompt: 'prompt',
  externalId: 'externalId',
  userId: 'userId',
  providerId: 'providerId',
  copyCount: 'copyCount',
  viewCount: 'viewCount',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  meta: 'meta',
  likeCount: 'likeCount',
  deletedAt: 'deletedAt',
  isArchived: 'isArchived',
  isPrivate: 'isPrivate',
  themeId: 'themeId',
  isRestricted: 'isRestricted',
  isQueued: 'isQueued',
  isNsfw: 'isNsfw'
};

exports.Prisma.AssetScalarFieldEnum = {
  id: 'id',
  format: 'format',
  src: 'src',
  height: 'height',
  width: 'width',
  color: 'color',
  meta: 'meta',
  order: 'order',
  promptId: 'promptId',
  createdAt: 'createdAt',
  cfUrl: 'cfUrl',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NotificationV2ScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  message: 'message',
  channel: 'channel',
  read: 'read',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  metadata: 'metadata',
  entityType: 'entityType',
  entityId: 'entityId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  image: 'image',
  username: 'username',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  meta: 'meta',
  isAdmin: 'isAdmin',
  name: 'name',
  deletedAt: 'deletedAt',
  emailVerified: 'emailVerified',
  subscriptionPlan: 'subscriptionPlan',
  queuedItems: 'queuedItems',
  isNew: 'isNew',
  password: 'password',
  stripe_customer_id: 'stripe_customer_id',
  preferredModelId: 'preferredModelId',
  subscriptionBillingCycle: 'subscriptionBillingCycle',
  lastBenefitsGrantDate: 'lastBenefitsGrantDate',
  modelCount: 'modelCount',
  preferredModelRepositoryId: 'preferredModelRepositoryId'
};

exports.Prisma.FollowerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  followTargetId: 'followTargetId',
  followDispatcherId: 'followDispatcherId'
};

exports.Prisma.LikeScalarFieldEnum = {
  id: 'id',
  promptId: 'promptId',
  userId: 'userId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ThemeLikeScalarFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  identifier: 'identifier',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.ThemeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId',
  image: 'image',
  accentColor: 'accentColor',
  thumbnails: 'thumbnails',
  meta: 'meta',
  modifiers: 'modifiers',
  negativeModifiers: 'negativeModifiers',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  isPublic: 'isPublic',
  likeCount: 'likeCount',
  category: 'category',
  isPro: 'isPro',
  slug: 'slug',
  tags: 'tags',
  mode: 'mode',
  relationship: 'relationship',
  primaryDarkColor: 'primaryDarkColor',
  secondaryDarkColor: 'secondaryDarkColor',
  lastSampleImageCreatedAt: 'lastSampleImageCreatedAt'
};

exports.Prisma.StyleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  strength: 'strength',
  verified: 'verified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.StyleCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  styleId: 'styleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CategoriesOnStylesScalarFieldEnum = {
  styleId: 'styleId',
  categoryId: 'categoryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.StylesOnPromptsScalarFieldEnum = {
  promptId: 'promptId',
  styleId: 'styleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.CommentScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  promptId: 'promptId',
  themeId: 'themeId',
  content: 'content',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.KeyvalueScalarFieldEnum = {
  id: 'id',
  key: 'key',
  value: 'value',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  notificationTargetId: 'notificationTargetId',
  notificationDispatcherId: 'notificationDispatcherId',
  type: 'type',
  message: 'message',
  isRead: 'isRead',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  promptId: 'promptId',
  themeId: 'themeId'
};

exports.Prisma.ModelScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  status: 'status',
  version: 'version',
  trainingId: 'trainingId',
  trainingMeta: 'trainingMeta',
  userId: 'userId',
  isComfy: 'isComfy',
  modelUrl: 'modelUrl',
  storageName: 'storageName',
  storageSource: 'storageSource',
  startedAt: 'startedAt',
  completedAt: 'completedAt',
  isArchived: 'isArchived',
  retryCount: 'retryCount',
  expirationDate: 'expirationDate',
  sampleModel: 'sampleModel',
  triggerWord: 'triggerWord',
  teamId: 'teamId',
  attributes: 'attributes',
  readableName: 'readableName',
  avatarUrl: 'avatarUrl',
  workflowRunId: 'workflowRunId',
  trainingData: 'trainingData',
  trainer: 'trainer',
  modelVersion: 'modelVersion',
  parentId: 'parentId',
  isLatest: 'isLatest',
  modelRepositoryId: 'modelRepositoryId',
  deprecatedName: 'deprecatedName',
  albumCount: 'albumCount',
  selfieUrl: 'selfieUrl'
};

exports.Prisma.ModelImageScalarFieldEnum = {
  id: 'id',
  imageUrl: 'imageUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  albumId: 'albumId',
  themeId: 'themeId',
  isLiked: 'isLiked',
  watermarkImageUrl: 'watermarkImageUrl',
  isShowcased: 'isShowcased',
  meta: 'meta',
  status: 'status',
  completedAt: 'completedAt',
  workflowName: 'workflowName',
  retryCount: 'retryCount',
  startedAt: 'startedAt'
};

exports.Prisma.AlbumScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  modelId: 'modelId',
  themeId: 'themeId',
  userId: 'userId',
  status: 'status',
  meta: 'meta',
  rating: 'rating',
  photoPackId: 'photoPackId',
  completedAt: 'completedAt',
  isOpened: 'isOpened',
  openedAt: 'openedAt',
  startedAt: 'startedAt',
  containerKey: 'containerKey',
  providerName: 'providerName',
  teamId: 'teamId',
  imageCount: 'imageCount',
  dislikedImageCount: 'dislikedImageCount',
  likedImageCount: 'likedImageCount',
  upscaledImageCount: 'upscaledImageCount'
};

exports.Prisma.AlbumModelsScalarFieldEnum = {
  albumId: 'albumId',
  modelId: 'modelId'
};

exports.Prisma.PaymentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  consumed: 'consumed',
  priceId: 'priceId',
  sessionId: 'sessionId',
  userId: 'userId',
  modelCredits: 'modelCredits',
  photoPackCredits: 'photoPackCredits',
  redoCredits: 'redoCredits',
  invitationBundlesPurchased: 'invitationBundlesPurchased',
  teamId: 'teamId'
};

exports.Prisma.GiftScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  consumed: 'consumed',
  giftEmail: 'giftEmail',
  paymentId: 'paymentId',
  userId: 'userId'
};

exports.Prisma.PromoCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  code: 'code',
  stripePriceId: 'stripePriceId',
  campaignId: 'campaignId',
  validTill: 'validTill',
  usageCount: 'usageCount',
  maxUsage: 'maxUsage',
  metadata: 'metadata'
};

exports.Prisma.CampaignScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  description: 'description',
  startDate: 'startDate',
  endDate: 'endDate'
};

exports.Prisma.RedeemedPromoCodeScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  promoCodeId: 'promoCodeId',
  campaignId: 'campaignId',
  redeemedAt: 'redeemedAt'
};

exports.Prisma.PoseScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  sdVersion: 'sdVersion',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.PhotoPackScalarFieldEnum = {
  id: 'id',
  templateName: 'templateName',
  model: 'model',
  coverImageUrl: 'coverImageUrl',
  positivePrompt: 'positivePrompt',
  negativePrompt: 'negativePrompt',
  guidanceScale: 'guidanceScale',
  image_size: 'image_size',
  steps: 'steps',
  sampler: 'sampler',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pose_image_ids: 'pose_image_ids',
  reference_image_ids: 'reference_image_ids',
  referenceImages: 'referenceImages',
  poseImages: 'poseImages',
  rootPrompt: 'rootPrompt',
  rootNegativePrompt: 'rootNegativePrompt'
};

exports.Prisma.ControlNetPosesScalarFieldEnum = {
  id: 'id',
  image_url: 'image_url',
  description: 'description',
  size: 'size',
  enabled: 'enabled',
  ogImageUrl: 'ogImageUrl',
  pose: 'pose',
  shot_type: 'shot_type',
  created_at: 'created_at',
  tags: 'tags'
};

exports.Prisma.ReferenceImageScalarFieldEnum = {
  id: 'id',
  imageUrl: 'imageUrl',
  strength: 'strength',
  description: 'description'
};

exports.Prisma.SamplePhotoScalarFieldEnum = {
  id: 'id',
  photoPackId: 'photoPackId',
  samplePhotoUrl: 'samplePhotoUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ModifierScalarFieldEnum = {
  id: 'id',
  tag_name: 'tag_name',
  value: 'value',
  gender_association: 'gender_association',
  category: 'category',
  sampleImageUrls: 'sampleImageUrls',
  label: 'label'
};

exports.Prisma.ImageWorkflowScalarFieldEnum = {
  id: 'id',
  model_image_id: 'model_image_id',
  workflow: 'workflow',
  provider_name: 'provider_name',
  provider_gpu: 'provider_gpu',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.UserCreditScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  modelCredits: 'modelCredits',
  photoPackCredits: 'photoPackCredits',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  redoCredits: 'redoCredits',
  groupPhotoCredits: 'groupPhotoCredits'
};

exports.Prisma.CreditTransactionScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  creditType: 'creditType',
  amount: 'amount',
  description: 'description',
  createdAt: 'createdAt'
};

exports.Prisma.ShoppingCartMetadataScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ThemeSampleImageScalarFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  imageUrl: 'imageUrl',
  sortOrder: 'sortOrder',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  prompt: 'prompt',
  modelId: 'modelId',
  compositeImageUrl: 'compositeImageUrl',
  gender: 'gender'
};

exports.Prisma.StorageLocationScalarFieldEnum = {
  id: 'id',
  provider: 'provider',
  bucket: 'bucket',
  path: 'path',
  region: 'region'
};

exports.Prisma.ModelStorageLocationScalarFieldEnum = {
  modelId: 'modelId',
  storageLocationId: 'storageLocationId'
};

exports.Prisma.UserDismissedItemScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  dismissedItemId: 'dismissedItemId',
  dismissedItemType: 'dismissedItemType',
  timeOfDismissal: 'timeOfDismissal',
  lastTimeUpdated: 'lastTimeUpdated',
  timeOfRemoval: 'timeOfRemoval'
};

exports.Prisma.TeamScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  ownerId: 'ownerId',
  logoUrl: 'logoUrl',
  companyRole: 'companyRole',
  companySize: 'companySize',
  companyIndustry: 'companyIndustry',
  allowedThemes: 'allowedThemes'
};

exports.Prisma.TeamMembershipScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  teamId: 'teamId',
  role: 'role',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  invitationBundleId: 'invitationBundleId'
};

exports.Prisma.TeamInvitationScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  email: 'email',
  invitedBy: 'invitedBy',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  deletedAt: 'deletedAt',
  acceptedAt: 'acceptedAt'
};

exports.Prisma.InvitationBundleScalarFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  paymentId: 'paymentId',
  isClaimed: 'isClaimed',
  createdAt: 'createdAt',
  claimedBy: 'claimedBy'
};

exports.Prisma.TeamMemberCreditsScalarFieldEnum = {
  id: 'id',
  teamMembershipId: 'teamMembershipId',
  modelCredits: 'modelCredits',
  photoPackCredits: 'photoPackCredits',
  redoCredits: 'redoCredits',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.PasswordResetTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.TeaserThemeScalarFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  modelRepositoryId: 'modelRepositoryId'
};

exports.Prisma.TeaserThemeImageScalarFieldEnum = {
  id: 'id',
  teaserThemeId: 'teaserThemeId',
  imageUrl: 'imageUrl',
  createdAt: 'createdAt',
  metadata: 'metadata',
  status: 'status'
};

exports.Prisma.ThemeUsageScalarFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  userId: 'userId',
  createdAt: 'createdAt'
};

exports.Prisma.TeamModelsScalarFieldEnum = {
  teamId: 'teamId',
  modelId: 'modelId',
  createdAt: 'createdAt',
  isImported: 'isImported'
};

exports.Prisma.TeamModelRepositoriesScalarFieldEnum = {
  teamId: 'teamId',
  modelRepositoryId: 'modelRepositoryId',
  isImported: 'isImported',
  createdAt: 'createdAt'
};

exports.Prisma.ModelRepositoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId',
  teamId: 'teamId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  defaultVersionId: 'defaultVersionId',
  albumCount: 'albumCount',
  meta: 'meta',
  avatarUrl: 'avatarUrl',
  claimToken: 'claimToken',
  claimTokenExpiresAt: 'claimTokenExpiresAt'
};

exports.Prisma.RecommendedThemeScalarFieldEnum = {
  id: 'id',
  modelRepositoryId: 'modelRepositoryId',
  themeId: 'themeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.LoraModelScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  triggerWords: 'triggerWords',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.ProviderOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  image: 'image',
  description: 'description',
  service: 'service',
  website: 'website'
};

exports.Prisma.PromptOrderByRelevanceFieldEnum = {
  id: 'id',
  prompt: 'prompt',
  externalId: 'externalId',
  userId: 'userId',
  providerId: 'providerId',
  themeId: 'themeId'
};

exports.Prisma.AssetOrderByRelevanceFieldEnum = {
  id: 'id',
  format: 'format',
  src: 'src',
  color: 'color',
  promptId: 'promptId',
  cfUrl: 'cfUrl'
};

exports.Prisma.NotificationV2OrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  message: 'message',
  entityType: 'entityType',
  entityId: 'entityId'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  image: 'image',
  username: 'username',
  email: 'email',
  name: 'name',
  subscriptionPlan: 'subscriptionPlan',
  password: 'password',
  stripe_customer_id: 'stripe_customer_id',
  preferredModelId: 'preferredModelId',
  subscriptionBillingCycle: 'subscriptionBillingCycle',
  preferredModelRepositoryId: 'preferredModelRepositoryId'
};

exports.Prisma.FollowerOrderByRelevanceFieldEnum = {
  id: 'id',
  followTargetId: 'followTargetId',
  followDispatcherId: 'followDispatcherId'
};

exports.Prisma.LikeOrderByRelevanceFieldEnum = {
  id: 'id',
  promptId: 'promptId',
  userId: 'userId'
};

exports.Prisma.ThemeLikeOrderByRelevanceFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  userId: 'userId'
};

exports.Prisma.AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionOrderByRelevanceFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId'
};

exports.Prisma.VerificationTokenOrderByRelevanceFieldEnum = {
  identifier: 'identifier',
  token: 'token'
};

exports.Prisma.ThemeOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId',
  image: 'image',
  accentColor: 'accentColor',
  thumbnails: 'thumbnails',
  category: 'category',
  slug: 'slug',
  tags: 'tags',
  mode: 'mode',
  relationship: 'relationship',
  primaryDarkColor: 'primaryDarkColor',
  secondaryDarkColor: 'secondaryDarkColor'
};

exports.Prisma.StyleOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.StyleCategoryOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  styleId: 'styleId'
};

exports.Prisma.CategoriesOnStylesOrderByRelevanceFieldEnum = {
  styleId: 'styleId',
  categoryId: 'categoryId'
};

exports.Prisma.StylesOnPromptsOrderByRelevanceFieldEnum = {
  promptId: 'promptId',
  styleId: 'styleId'
};

exports.Prisma.CommentOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  promptId: 'promptId',
  themeId: 'themeId',
  content: 'content'
};

exports.Prisma.keyvalueOrderByRelevanceFieldEnum = {
  id: 'id',
  key: 'key'
};

exports.Prisma.NotificationOrderByRelevanceFieldEnum = {
  id: 'id',
  notificationTargetId: 'notificationTargetId',
  notificationDispatcherId: 'notificationDispatcherId',
  type: 'type',
  message: 'message',
  promptId: 'promptId',
  themeId: 'themeId'
};

exports.Prisma.ModelOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  status: 'status',
  version: 'version',
  trainingId: 'trainingId',
  userId: 'userId',
  modelUrl: 'modelUrl',
  storageName: 'storageName',
  storageSource: 'storageSource',
  triggerWord: 'triggerWord',
  teamId: 'teamId',
  readableName: 'readableName',
  avatarUrl: 'avatarUrl',
  workflowRunId: 'workflowRunId',
  trainer: 'trainer',
  modelVersion: 'modelVersion',
  parentId: 'parentId',
  modelRepositoryId: 'modelRepositoryId',
  deprecatedName: 'deprecatedName',
  selfieUrl: 'selfieUrl'
};

exports.Prisma.ModelImageOrderByRelevanceFieldEnum = {
  id: 'id',
  imageUrl: 'imageUrl',
  albumId: 'albumId',
  themeId: 'themeId',
  watermarkImageUrl: 'watermarkImageUrl',
  status: 'status',
  workflowName: 'workflowName'
};

exports.Prisma.AlbumOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  modelId: 'modelId',
  themeId: 'themeId',
  userId: 'userId',
  status: 'status',
  containerKey: 'containerKey',
  providerName: 'providerName',
  teamId: 'teamId'
};

exports.Prisma.AlbumModelsOrderByRelevanceFieldEnum = {
  albumId: 'albumId',
  modelId: 'modelId'
};

exports.Prisma.PaymentOrderByRelevanceFieldEnum = {
  id: 'id',
  priceId: 'priceId',
  sessionId: 'sessionId',
  userId: 'userId',
  teamId: 'teamId'
};

exports.Prisma.GiftOrderByRelevanceFieldEnum = {
  id: 'id',
  giftEmail: 'giftEmail',
  paymentId: 'paymentId',
  userId: 'userId'
};

exports.Prisma.PromoCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  code: 'code',
  stripePriceId: 'stripePriceId',
  campaignId: 'campaignId'
};

exports.Prisma.CampaignOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description'
};

exports.Prisma.RedeemedPromoCodeOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  promoCodeId: 'promoCodeId',
  campaignId: 'campaignId'
};

exports.Prisma.PoseOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  sdVersion: 'sdVersion'
};

exports.Prisma.PhotoPackOrderByRelevanceFieldEnum = {
  templateName: 'templateName',
  model: 'model',
  coverImageUrl: 'coverImageUrl',
  positivePrompt: 'positivePrompt',
  negativePrompt: 'negativePrompt',
  image_size: 'image_size',
  sampler: 'sampler',
  referenceImages: 'referenceImages',
  poseImages: 'poseImages',
  rootPrompt: 'rootPrompt',
  rootNegativePrompt: 'rootNegativePrompt'
};

exports.Prisma.ControlNetPosesOrderByRelevanceFieldEnum = {
  image_url: 'image_url',
  description: 'description',
  ogImageUrl: 'ogImageUrl',
  tags: 'tags'
};

exports.Prisma.ReferenceImageOrderByRelevanceFieldEnum = {
  imageUrl: 'imageUrl',
  description: 'description'
};

exports.Prisma.SamplePhotoOrderByRelevanceFieldEnum = {
  samplePhotoUrl: 'samplePhotoUrl'
};

exports.Prisma.ModifierOrderByRelevanceFieldEnum = {
  tag_name: 'tag_name',
  value: 'value',
  sampleImageUrls: 'sampleImageUrls',
  label: 'label'
};

exports.Prisma.ImageWorkflowOrderByRelevanceFieldEnum = {
  id: 'id',
  model_image_id: 'model_image_id',
  provider_name: 'provider_name',
  provider_gpu: 'provider_gpu'
};

exports.Prisma.UserCreditOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.CreditTransactionOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  creditType: 'creditType',
  description: 'description'
};

exports.Prisma.ShoppingCartMetadataOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId'
};

exports.Prisma.ThemeSampleImageOrderByRelevanceFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  imageUrl: 'imageUrl',
  prompt: 'prompt',
  modelId: 'modelId',
  compositeImageUrl: 'compositeImageUrl',
  gender: 'gender'
};

exports.Prisma.StorageLocationOrderByRelevanceFieldEnum = {
  id: 'id',
  provider: 'provider',
  bucket: 'bucket',
  path: 'path',
  region: 'region'
};

exports.Prisma.ModelStorageLocationOrderByRelevanceFieldEnum = {
  modelId: 'modelId',
  storageLocationId: 'storageLocationId'
};

exports.Prisma.UserDismissedItemOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  dismissedItemId: 'dismissedItemId',
  dismissedItemType: 'dismissedItemType'
};

exports.Prisma.TeamOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  ownerId: 'ownerId',
  logoUrl: 'logoUrl',
  companyRole: 'companyRole',
  companySize: 'companySize',
  companyIndustry: 'companyIndustry',
  allowedThemes: 'allowedThemes'
};

exports.Prisma.TeamMembershipOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  teamId: 'teamId',
  role: 'role',
  invitationBundleId: 'invitationBundleId'
};

exports.Prisma.TeamInvitationOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  email: 'email',
  invitedBy: 'invitedBy'
};

exports.Prisma.InvitationBundleOrderByRelevanceFieldEnum = {
  id: 'id',
  teamId: 'teamId',
  paymentId: 'paymentId',
  claimedBy: 'claimedBy'
};

exports.Prisma.TeamMemberCreditsOrderByRelevanceFieldEnum = {
  id: 'id',
  teamMembershipId: 'teamMembershipId'
};

exports.Prisma.PasswordResetTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token'
};

exports.Prisma.TeaserThemeOrderByRelevanceFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  modelRepositoryId: 'modelRepositoryId'
};

exports.Prisma.TeaserThemeImageOrderByRelevanceFieldEnum = {
  id: 'id',
  teaserThemeId: 'teaserThemeId',
  imageUrl: 'imageUrl'
};

exports.Prisma.ThemeUsageOrderByRelevanceFieldEnum = {
  id: 'id',
  themeId: 'themeId',
  userId: 'userId'
};

exports.Prisma.TeamModelsOrderByRelevanceFieldEnum = {
  teamId: 'teamId',
  modelId: 'modelId'
};

exports.Prisma.TeamModelRepositoriesOrderByRelevanceFieldEnum = {
  teamId: 'teamId',
  modelRepositoryId: 'modelRepositoryId'
};

exports.Prisma.ModelRepositoryOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  userId: 'userId',
  teamId: 'teamId',
  defaultVersionId: 'defaultVersionId',
  avatarUrl: 'avatarUrl',
  claimToken: 'claimToken'
};

exports.Prisma.RecommendedThemeOrderByRelevanceFieldEnum = {
  id: 'id',
  modelRepositoryId: 'modelRepositoryId',
  themeId: 'themeId'
};

exports.Prisma.LoraModelOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  triggerWords: 'triggerWords'
};
exports.NotificationChannel = exports.$Enums.NotificationChannel = {
  email: 'email',
  in_app: 'in_app',
  push: 'push'
};

exports.size_type = exports.$Enums.size_type = {
  square: 'square',
  tall: 'tall',
  wide: 'wide'
};

exports.pose_type = exports.$Enums.pose_type = {
  standing: 'standing',
  sitting: 'sitting'
};

exports.shot_type = exports.$Enums.shot_type = {
  wide_shot: 'wide_shot',
  closeup: 'closeup',
  headshot: 'headshot',
  unknown: 'unknown'
};

exports.Gender_Association = exports.$Enums.Gender_Association = {
  male: 'male',
  female: 'female',
  gender_neutral: 'gender_neutral'
};

exports.tag_category_type = exports.$Enums.tag_category_type = {
  clothing: 'clothing',
  location: 'location',
  color: 'color',
  photography: 'photography',
  scene: 'scene',
  camera: 'camera',
  hairStyle: 'hairStyle',
  facialHairStyle: 'facialHairStyle',
  shirt: 'shirt',
  jacket: 'jacket',
  pants: 'pants',
  shoes: 'shoes',
  glasses: 'glasses',
  hat: 'hat',
  outfit: 'outfit',
  ethnicity: 'ethnicity',
  bodyType: 'bodyType',
  eyeColor: 'eyeColor',
  hairLength: 'hairLength',
  shotType: 'shotType',
  time: 'time',
  costume: 'costume',
  hairColor: 'hairColor',
  emotion: 'emotion',
  upperClothing: 'upperClothing'
};

exports.teaser_status_enum = exports.$Enums.teaser_status_enum = {
  ready: 'ready',
  sent: 'sent',
  delivered: 'delivered'
};

exports.Prisma.ModelName = {
  Provider: 'Provider',
  Prompt: 'Prompt',
  Asset: 'Asset',
  NotificationV2: 'NotificationV2',
  User: 'User',
  Follower: 'Follower',
  Like: 'Like',
  ThemeLike: 'ThemeLike',
  Account: 'Account',
  Session: 'Session',
  VerificationToken: 'VerificationToken',
  Theme: 'Theme',
  Style: 'Style',
  StyleCategory: 'StyleCategory',
  CategoriesOnStyles: 'CategoriesOnStyles',
  StylesOnPrompts: 'StylesOnPrompts',
  Comment: 'Comment',
  keyvalue: 'keyvalue',
  Notification: 'Notification',
  Model: 'Model',
  ModelImage: 'ModelImage',
  Album: 'Album',
  AlbumModels: 'AlbumModels',
  Payment: 'Payment',
  Gift: 'Gift',
  PromoCode: 'PromoCode',
  Campaign: 'Campaign',
  RedeemedPromoCode: 'RedeemedPromoCode',
  Pose: 'Pose',
  PhotoPack: 'PhotoPack',
  ControlNetPoses: 'ControlNetPoses',
  ReferenceImage: 'ReferenceImage',
  SamplePhoto: 'SamplePhoto',
  Modifier: 'Modifier',
  ImageWorkflow: 'ImageWorkflow',
  UserCredit: 'UserCredit',
  CreditTransaction: 'CreditTransaction',
  ShoppingCartMetadata: 'ShoppingCartMetadata',
  ThemeSampleImage: 'ThemeSampleImage',
  StorageLocation: 'StorageLocation',
  ModelStorageLocation: 'ModelStorageLocation',
  UserDismissedItem: 'UserDismissedItem',
  Team: 'Team',
  TeamMembership: 'TeamMembership',
  TeamInvitation: 'TeamInvitation',
  InvitationBundle: 'InvitationBundle',
  TeamMemberCredits: 'TeamMemberCredits',
  PasswordResetToken: 'PasswordResetToken',
  TeaserTheme: 'TeaserTheme',
  TeaserThemeImage: 'TeaserThemeImage',
  ThemeUsage: 'ThemeUsage',
  TeamModels: 'TeamModels',
  TeamModelRepositories: 'TeamModelRepositories',
  ModelRepository: 'ModelRepository',
  RecommendedTheme: 'RecommendedTheme',
  LoraModel: 'LoraModel'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
